import { AdministrationNewMoneyPage } from "../pages/administration";

const AdministrationNewMoneyRoutes = {
    path: 'newmoney/*',
    roles: [],
    element: AdministrationNewMoneyPage
};

export default AdministrationNewMoneyRoutes;